import { useEffect } from 'react';
import { enableMediaPlaybackClicked } from 'features/streaming/thunks/enableMediaPlaybackClicked';
import { useAppDispatch } from 'store/hooks';

/**
 * Mirrors ReceivingFeed's main-document gesture listeners onto the Document PiP window.
 *
 * A user gesture is scoped to the window it happens in: clicks in the PiP window grant
 * activation to the PiP document only, so the main-document listeners never see them and
 * cannot unblock <video> elements living inside the PiP document. Capture phase, like the
 * main-document originals, so the retry runs even when a target stops propagation.
 */
export const useRetryBlockedMediaOnPipGesture = (pipWindow: Window | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!pipWindow) {
      return undefined;
    }

    const retryBlockedMedia = () => dispatch(enableMediaPlaybackClicked());

    pipWindow.document.addEventListener('click', retryBlockedMedia, true);
    pipWindow.document.addEventListener('touchend', retryBlockedMedia, true);

    return () => {
      pipWindow.document.removeEventListener('click', retryBlockedMedia, true);
      pipWindow.document.removeEventListener('touchend', retryBlockedMedia, true);
    };
  }, [pipWindow, dispatch]);
};
